function setStudents(data) {
	return {
		type: 'SET_STUDENTS',
		payload: data,
	};
}

export { setStudents };
